import {
	formatKnowledgeSourceLabel as formatKnowledgeSourceLabelBase,
	iconMapper as iconMapperBase,
} from '@atlassian/conversation-assistant-utils/knowledge-source-icons';

export const formatKnowledgeSourceLabel = (source: string): string =>
	formatKnowledgeSourceLabelBase(source);

export const iconMapper: {
	[x: string]: JSX.Element;
} = {
	...iconMapperBase,
};
